import React from 'react';
import { Image, StyleSheet, Text, View } from '../base_components';

import ImageButton from '../buttons/image_button';
import CloseButton from '../buttons/close_button';
import { Game } from './data/games';

const styles = StyleSheet.create({
  gameOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleWrapper: {
    marginLeft: '2em',
    marginRight: '2em',
    marginBottom: '1em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleText: {
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  image: {
    width: '15em',
    height: '15em',
    borderRadius: '1em',
  },
  appleButton: {
    marginTop: '4em',
    width: 512 * 0.03 + 'em',
    height: 171 * 0.03 + 'em',
  },
  googleButton: {
    marginTop: '2em',
    width: 564 * 0.03 + 'em',
    height: 168 * 0.03 + 'em',
  },
  close: {
    position: 'absolute',
    top: '1em',
    right: '1em',
    height: '3em',
    width: '3em',
  },
});

type Props = {
  style?: any;
  game: Game;
  onDone: () => void;
};

const GOOGLE_IMG = require('../../assets/img/google_play_button.png');
const APPLE_IMG = require('../../assets/img/app_store_button.png');

export default class GameOverlay extends React.PureComponent<Props> {
  _onApplePress = () => {
    const { itunes_url } = this.props.game;
    window.open(itunes_url, '_blank');
  };
  _onGooglePress = () => {
    const { play_url } = this.props.game;
    window.open(play_url, '_blank');
  };
  render() {
    const { style, game, onDone } = this.props;
    const { display_name, image_url } = game;
    return (
      <View style={[styles.gameOverlay, style]}>
        <View style={styles.titleWrapper}>
          <Text style={styles.titleText}>{display_name}</Text>
        </View>
        <Image style={styles.image} source={image_url} />
        <ImageButton
          style={styles.appleButton}
          source={APPLE_IMG}
          onPress={this._onApplePress}
        />
        <ImageButton
          style={styles.googleButton}
          source={GOOGLE_IMG}
          onPress={this._onGooglePress}
        />
        <CloseButton style={styles.close} onPress={onDone} />
      </View>
    );
  }
}
